import {useEffect} from "react";
import {reaction} from "mobx";
import type {IFilterState} from "../../../data/models/filter/Filter";
import type {ViewChangeType} from "../../../data/models/ViewUtils";
import type {View} from "../../../data/models/View";

export function useUnsavedFilters(selectedView: View, onChangesDetected: (changes: ViewChangeType[]) => void) {
	useEffect(() => {
		if (!selectedView) {
			onChangesDetected([]);
			return;
		}

		const dispose = reaction(
			() => {
				const isAdvanced = selectedView.filters.type === "advanced";

				const oldChanges = selectedView.getSavedDataForType("filters", false) as IFilterState;
				const newChanges = selectedView.getNewDataForType("filters", false) as IFilterState;

				if (isAdvanced) {
					return JSON.stringify(oldChanges?.filters?.advanced) !== JSON.stringify(newChanges?.filters?.advanced);
				} else {
					return JSON.stringify(oldChanges?.filters?.simple) !== JSON.stringify(newChanges?.filters?.simple);
				}
			},
			(hasUnsavedChanges) => {
				onChangesDetected(hasUnsavedChanges ? ["filters"] : []);
			},
			{fireImmediately: true},
		);

		return () => dispose();
	}, [selectedView, onChangesDetected]);
}
